<app-page-title title="Revisar Respostas"></app-page-title>
<mat-progress-bar mode="indeterminate" *ngIf="showLoader"></mat-progress-bar>

<div class="review-container" *ngIf="answerData">
  <div class="header-actions">
    <button class="btn-secundary" [routerLink]="['/devocional/view', answerData?.quiz?.id]">Voltar</button>
  </div>

  <div class="profile-card">
    <div class="profile-info">
      <div class="avatar-wrapper">
        <img *ngIf="answerData?.user?.avatar" [src]="getAvatarUrl(answerData.user.avatar)" />
        <div *ngIf="!answerData?.user?.avatar" class="avatar-initial">{{ getFirstLetter(answerData?.user?.name) }}</div>
      </div>
      <div class="member-details">
        <span class="member-title">Respostas de</span>
        <h2 class="member-name">{{ formatShortName(answerData?.user?.name) }}</h2>
      </div>
    </div>
  </div>

  <div class="content-card">
    <div class="quiz-context">
      <h3 class="quiz-title">{{ answerData?.quiz?.title }}</h3>
      <p class="quiz-text">{{ answerData?.quiz?.text }}</p>
    </div>

    <mat-divider></mat-divider>

    <div class="qa-section">
      <div class="qa-block">
        <p class="question-title">{{ answerData?.question_1 || answerData?.quiz?.question_1 }}</p>
        <div class="answer-box">
          <p class="answer-text">{{ answerData?.answer_1 || 'Não respondida' }}</p>
        </div>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ answerData?.question_2 || answerData?.quiz?.question_2 }}</p>
        <div class="answer-box">
          <p class="answer-text">{{ answerData?.answer_2 || 'Não respondida' }}</p>
        </div>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ answerData?.question_3 || answerData?.quiz?.question_3 }}</p>
        <div class="answer-box">
          <p class="answer-text">{{ answerData?.answer_3 || 'Não respondida' }}</p>
        </div>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ answerData?.question_4 || answerData?.quiz?.question_4 }}</p>
        <div class="answer-box">
          <p class="answer-text">{{ answerData?.answer_4 || 'Não respondida' }}</p>
        </div>
      </div>

      <div class="qa-block">
        <p class="question-title">{{ answerData?.question_5 || answerData?.quiz?.question_5 }}</p>
        <div class="answer-box">
          <p class="answer-text">{{ answerData?.answer_5 || 'Não respondida' }}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="feedback-card">
    <h3 class="feedback-title">Seu Feedback (Observações)</h3>
    <p class="feedback-subtitle">Deixe aqui a sua revisão ou conselho a respeito do devocional respondido.</p>

    <form [formGroup]="reviewForm">
      <mat-form-field appearance="outline" class="full-width">
        <textarea matInput formControlName="feedback" rows="5" placeholder="Escreva seu feedback..."></textarea>
      </mat-form-field>

      <div class="form-actions">
        <button class="btn-primary" [disabled]="reviewForm.invalid" (click)="onSubmit()">Salvar Revisão</button>
      </div>
    </form>
  </div>
</div>
